import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

export const SiteHeader = () => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-[#0A0A0A] bg-white/80 backdrop-blur-xl"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="site-brand" aria-label="BankDesks home">
          <img
            src="/logo.svg"
            alt=""
            width="36"
            height="36"
            className="w-9 h-9 block transition-transform group-hover:-translate-y-px"
          />
          <div className="flex flex-col leading-tight">
            <span className="font-display font-black text-[16px] tracking-[-0.01em] text-[#0A0A0A]">
              BankDesks<span className="text-[#FF3333]">.</span>com
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#4B5563]">
              India · Banks &amp; NBFCs
            </span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="#directory" className="hover:text-[#002FA7] transition-colors" data-testid="nav-directory">
            Directory
          </a>
          <a href="#stats" className="hover:text-[#002FA7] transition-colors" data-testid="nav-stats">
            Coverage
          </a>
          <a
            href="https://rbi.org.in"
            target="_blank"
            rel="noreferrer"
            className="hover:text-[#002FA7] transition-colors"
            data-testid="nav-rbi"
          >
            RBI Source
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/resolve"
            data-testid="nav-resolve"
            className="inline-flex items-center gap-1.5 bg-[#0A0A0A] text-white font-bold px-3 sm:px-4 py-2 text-xs uppercase tracking-[0.15em] hover:bg-[#FF3333] transition-colors"
          >
            <ShieldAlert className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Resolve an issue</span>
            <span className="sm:hidden">Resolve</span>
          </Link>
        </div>
      </div>
    </header>
  );
};
